import { Box, Grid, Typography } from '@mui/material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { DropzoneField } from "../../../../../components/forms/DropzoneField";
import { FilePutFields } from "../../../api/file-fields";
import CardActions from '../../../components/CardActions';
import { ArchivoFormData } from "../../../components/DialogNuevoArchivo";

interface SeccionNuevoNOTESArchivoProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoNOTESArchivo = ({ formMethods }: SeccionNuevoNOTESArchivoProps) => {
  const { control, setValue, resetField } = formMethods

  const watchArchivo = useWatch({
    control,
    name: FilePutFields.File
  });

  return (
    <CardActions title='Gráfico de precios de variación de sub-yacentes' icon='mdi:chart-line' colapsable>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant='body2' sx={{ mb: 2 }}>
            Si la nota requiere un gráfico o documentación respaldatoria, adjúntela aquí:
          </Typography>
          <Box sx={{ minHeight: '100px' }}>
            {watchArchivo ? (
              <ArchivoFormData
                archivo={watchArchivo}
                onRemove={() => resetField(FilePutFields.File)}
              />
            ) : (
              <DropzoneField
                name={FilePutFields.File}
                control={control}
                setValue={setValue}
                accept={{
                'image/*': ['.jpeg', '.jpg', '.png', '.webp']
              }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </CardActions>
  )
}

export default SeccionNuevoNOTESArchivo
